<template>

    <div class="content">

        <div class="intro" 
            v-bind:style="{
                backgroundImage: get_project_image(),
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundColor: 'black',
                backgroundPosition: 'center'
            }">

            <div class="overlay">

                <div class="wrapper">
                    <p class="subline">{{ project.subline }}</p>
                    <h1 class="headline">{{ project.name }}</h1>

                    <p class="description">
                        {{ project.short_description }}
                    </p>


                </div>

            </div>

        </div>

        <div class="phases__container">

                <div v-for="phase, index in project.phases" v-bind:key="index" :class="'phase_' + (phase.order + 1)" :id="'phase'+ (phase.order + 1)">

                    <project-phase :phase="phase" :all_phases="project.phases"></project-phase>
                    
                </div>

            <template v-if="on_project_page()">
                <div class="phase__points">

                    <div v-for="phase, index in project.phases" v-bind:key="index" class="point__wrapper" @click="toPhase(phase.order + 1)">
                        <div class="point"></div>
                        <div class="text">
                            <!-- <p>PHASE {{ phase.order + 1 }}</p> -->
                            <p>{{ phase.title }}</p>
                        </div>
                    </div>

                </div>
            </template>

        </div>

        <template v-if="has_social_links()">
        
            <div class="social__icons">

                <h3 class="headline">SOCIAL LINKS</h3>

                <div class="row">

                    <template v-if="project.discord">
                        <a :href="project.discord" title="discord" target="_blank"><img src="/images/icons/discord.webp" alt="discord"/></a>
                    </template>

                    <template v-if="project.twitter">
                        <a :href="project.twitter" title="twitter" target="_blank"><img src="/images/icons/twitter.webp" alt="twitter"/></a>
                    </template>

                    <template v-if="project.steam">
                        <a :href="project.steam" title="steam" target="_blank"><img src="/images/icons/steam.webp" alt="steam"/></a>
                    </template>

                    <template v-if="project.facebook">
                        <a :href="project.facebook" title="facebook" target="_blank"><img src="/images/icons/facebook.webp" alt="facebook"/></a>
                    </template>

                    <template v-if="project.instagram">
                        <a :href="project.instagram" title="instagram" target="_blank"><img src="/images/icons/instagram.webp" alt="instagram"/></a>
                    </template>

                    <template v-if="project.youtube">
                        <a :href="project.youtube" title="youtube" target="_blank"><img src="/images/icons/youtube.webp" alt="youtube"/></a>
                    </template>

                </div>

                

            </div>

        </template>

        <template v-if="on_project_page()">
            <projects-showcase :left_image="showcase_left_image" :right_image="showcase_right_image" :projects="projects" :featured="featured"></projects-showcase>
        </template>

    </div>

</template>
<script>
export default {
    data(){
        return {
            text: "Project page"
        }
    },
    props: ['project', 'projects', 'featured', 'showcase_left_image', 'showcase_right_image'],
    methods: {
        has_social_links(){
            if(this.project.discord || this.project.twitter || this.project.steam || this.project.facebook || this.project.instagram || this.project.youtube){
                return true;
            }
            return false;
        },
        get_project_image(){
            return "url('" + '/image/' + this.project.media_path + '/' + this.project.featured_image + "')";
        },
        toPhase(order){
            const phase  = document.getElementById('phase' + order);
            const yPos = phase.offsetTop - document.getElementsByTagName('header')[0].clientHeight - 20;
            window.scrollTo(0, yPos);
            // document.getElementById().scrollIntoView('phase' + order);
        },
        on_project_page(){
            if(window.location.pathname == "/projects") return false;
            return true;
        }
    }
}
</script>

<style lang="scss" scoped>

    .intro{
        position: relative;
        height: 490px;

        // background: url('/images/contact/hero.webp');
        // background-repeat: no-repeat;
        // // background-position: center -140px;
        // background-size: cover;
        // background-color: black;

        .overlay{
            display: block;
            width: 100%;
            height: 100%;
            position: relative;

            background: rgba(92, 44, 144, 0.6);

            .wrapper{
                display: block;
                position: absolute;
                top: 57%; right: 50%;
                transform: translate(50%, -50%);
                // width: 976px;
                width: 100%;
                max-width: 1020px;
                height: auto;

                .subline{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 14px;
                    line-height: 17px;
                    text-align: left;
                    text-transform: uppercase;

                    color: #ED1163;
                }

                h1.headline{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 100px;
                    line-height: 100px;
                    /* or 100% */
                    margin: 0;
                    text-transform: uppercase;

                    color: #FFFFFF;

                    margin-left: -5px;
                }

                .description{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;;
                    font-style: normal;
                    // font-weight: 400;
                    font-size: 18px;
                    line-height: 22px;

                    color: #FFFFFF;

                    margin: 0;
                    margin-top: 22px;
                    // text-align: center;
                    text-align: left;
                    width: 100%;
                    // max-width: 454px;
                    margin-left: 0;
                    margin-right: auto;

                    color: #FFFFFF;
                }


            }

        }
    }

    .phases__container{
        display: flex;
        flex-direction: column;
        // background: black;

        .phase__points{
            
            position: fixed;
            top: 50%;
            left: 25px;

            .point__wrapper{
                display: flex;
                flex-direction: row;
                user-select: none;
                cursor: pointer;

                .point{
                    width: 10px;
                    height: 10px;
                    background: rgba(0, 0, 0, 0.3);
                    border: 1px solid #ED1163;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    border-radius: 50%;
                    margin-bottom: 37px;
                    transition: all .7s ease;
                    
                    margin-top: 7px;
                }

                .text{
                    display: flex;
                    flex-direction: column;
                    opacity: 0;
                    transition: all .7s ease;

                    p{
                        text-transform: uppercase;
                        margin: 0;
                        margin-left: 7px;

                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        font-size: 12px;
                        // line-height: 15px;
                        line-height: 28px;


                        color: #ED1163;
                    }
                }

                &:hover{
                    .point{
                        background: #ED1163;
                        transform: scale(1.5);
                    }

                    .text{
                        opacity: 1;
                    }
                        
                }
            }

            
        }

        .phase_1{
            clip-path: polygon(50% 0, 100% 0, 100% 100%, 50% 90%, 0 75%, 0 0);
        }

        .phase_2{
            // clip-path: polygon(50% 15%, 100% 20%, 100% 100%, 0 100%, 0 0);
        }

        // .phase_3{}

        // .phase_4{}
    }

    .social__icons{
        display: flex;
        flex-direction: column;
        // justify-content: center;
        background: black;
        padding: 120px 0;

        .headline{
            font-family: "DIN Next LT Pro Bold", Tahoma, Verdana, sans-serif;;
            font-style: normal;
            font-size: 30px;
            line-height: 36px;
            margin: 0;
            color: #FFFFFF;
            text-transform: uppercase;
            text-align: center;
        }

        .row{
            display: flex;
            flex-direction: row;
            justify-content: center;

            margin-top: 42px;

            a{
                display: block;
                margin: 0 25px;

                img{
                    display: block;
                    width: 24px;
                    height: 24px;
                }
            }
        }

    }


    @media screen and (max-width: 836px) {

        .intro{
            
            .overlay{

                .wrapper{
                    width: 95%;
                    margin: auto;

                    .subline{
                        font-size: 20px;
                        line-height: 24px;
                        text-align: center;
                        margin-bottom: 15px;
                    }

                    h1.headline{
                        font-size: 40px;
                        line-height: 40px;
                        text-align: center;
                    }

                    .description{
                        text-align: center;
                    }

                    .keywords{
                        font-size: 16px;
                        line-height: 16px;
                    }

                    a.anim_button{
                        width: 100%;
                        max-width: 245px;
                        height: 35px;
                        
                        p{
                            font-size: 12px;
                            line-height: 40px;
                        }
                    }
                }

                .bottom__bar{
                    .text-wrap{
                        .red_text, .regular_text, .red_text.second{
                            font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                            font-size: 18px;
                            line-height: 25px;
                        }   
                    }
                }
            }
        }

        .phases__container{

            .phase__points{
                display: none;
            }

            .phase_1{
                clip-path: none;
            }
        }

    }

</style>